export const MONETIZATION_TYPES = {
  REFERRAL: 'referral',
  REQUEST_SHORT: 'request-short',
  REQUEST_LONG: 'request-long',
  COMMISSION: 'commission',
  PROMO_CODE: 'promo-code',
  APPROVAL: 'approval',
};

export const SORT_PROPERTIES = {
  POSITION_ON_LANDING: 'advertising.positionOnLanding',
};
